import { useState } from "react";
import Banner from "../../components/Banner";
import ErrorAlertCard from "../../components/Cards/ErrorAlertCard";
import { Categorias } from "../../components/page_components/PesquisasPage/Categorias";
import { ListaDePesquisas } from "../../components/page_components/PesquisasPage/ListaDePesquisas";
import { SecaoBarraDePesquisa } from "../../components/page_components/PesquisasPage/SecaoBarraDePesquisa";
import LoadingScreen from "../../components/StatusScreens/MediumLoadingScreen";
import { useAxios } from "../../hooks/useAxios";

import * as S from "./styles";

//observatorio_react\src\pages\Pesquisas
export default function Pesquisas() {
  const [searchState, setSearchState] = useState("all");
  const [categoria, setCategoria] = useState("all");

  const uri = `/pesquisas/?filtro=${searchState}&categorias=${categoria}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <>
      <Banner
        titulo="Pesquisas"
        subtitulo={`Aqui você encontra links para publicações de pesquisas 
        importantes sobre condições de trabalho, saúde e segurança dos(as) 
        trabalhadores(as) da saúde, além de pesquisas sobre ações de enfrentamento
         à covid-19.`}
      />
      <S.Container>
        <SecaoBarraDePesquisa setState={setSearchState} />
        {loading && <LoadingScreen />}
        {error && (
          <div
            style={{
              height: "500px",
              padding: "0px 30px",
            }}
          >
            <ErrorAlertCard
              descricao={"Não foi possível carregar as pesquisas"}
              erroMsg={error}
            />
          </div>
        )}
        {response && (
          <>
            <Categorias
              selectedCategoria={categoria}
              setCategoria={setCategoria}
              listaDeCategorias={response.dados.categorias}
            />
            <ListaDePesquisas pesquisas={response.dados.pesquisas} />
          </>
        )}
      </S.Container>
    </>
  );
}
